import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { UsersPage } from "@/features/users";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/users/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    // Redirect collaborators to request page
    if (userData?.user?.roleName === USER_ROLES.COLLABORATOR) {
      // TODO: remove "as string" when the requests page is done
      throw redirect({ to: "/requests" as string });
    }
  },
  component: UsersView,
});

function UsersView() {
  usePageTitle("Users");

  return <UsersPage />;
}
